import { PromoCode } from "@/types/dto/common/dynamic-cta";
import { useTranslations } from "next-intl";

const promoCodeFactory = (
  data: any,
  t?: ReturnType<typeof useTranslations>
): PromoCode => ({
  promoCodeLabel: data?.promoCodeLabel || (t ? t("Use Code") : ""),
  promoCode: data?.promoCode ?? ""
});

export default promoCodeFactory;